/**
 * Canonical chunk size for PostgREST `.in()` id lists (#1944/#1951): one giant
 * id list makes PostgREST reject the GET with "URI too long" at ~287+ ids.
 * 100 ids keeps the URL comfortably under the limit.
 */
export const IN_LIST_CHUNK_SIZE = 100;

/**
 * Split a list into fixed-size chunks. Primary use: keeping PostgREST `.in()`
 * lists and page sizes under the 1000-row response cap, which silently
 * truncates larger result sets.
 *
 * @throws {RangeError} when `size` is less than 1 (or NaN) — a zero/negative
 * chunk size would otherwise loop forever. Callers must pass a positive size.
 */
export function chunkList<T>(items: readonly T[], size: number): T[][] {
  if (!(size >= 1)) {
    throw new RangeError(`chunkList size must be >= 1, got ${size}`);
  }
  const chunks: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    chunks.push(items.slice(i, i + size));
  }
  return chunks;
}
